// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import ACCOUNT_CONSTANTS from '@tcp/core/src/components/features/account/Account/Account.constants';
import Row from '../../../../../../common/atoms/Row';
import Col from '../../../../../../common/atoms/Col';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';

import MyProfileTile from '../../../../../../common/molecules/MyProfileTile';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import MyProfileLabels, { ACCOUNT_PROFILE } from '../../../views/MyProfile.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblPassword,
} from '../../../../../../../utils/labels/globalGeneric.labels';

const ChangePassword = () => {
  const accountProfileLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_PROFILE, MyProfileLabels);

  const clickEventdata = {
    customEvents: [],
    eventName: ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS.navigationName.profile_changePassword,
    pageNavigationText: ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS.navigationText.profile_changePassword,
  };
  return (
    <MyProfileTile
      title={renderLabel(
        getLabelFromCopyOrFromTranslation(
          `${GLOBAL_GENERIC_LABELS}.${lblPassword}`,
          GlobalGenericLabels
        ),
        'lbl_password'
      )}
      ctaTitle={renderLabel(
        accountProfileLabels?.lbl_profile_change_password,
        'lbl_profile_change_password'
      )}
      ctaPath="/account/profile"
      ctaLink="/account?id=profile&subSection=change-password"
      dataLocator="pi-changepassword"
      clickEventdata={clickEventdata}
    >
      <BodyCopy component="div">
        <Row fullBleed>
          <Col
            colSize={{
              small: 6,
              medium: 8,
              large: 12,
            }}
          >
            <BodyCopy
              className="elem-pb-SM"
              fontSize="fs16"
              data-locator="pi-passwordtextheader"
              fontFamily="secondary"
            >
              {renderLabel(
                accountProfileLabels?.lbl_profile_change_your_password,
                'lbl_profile_change_your_password'
              )}
            </BodyCopy>
          </Col>
        </Row>
        <Row fullBleed>
          <Col
            colSize={{
              small: 6,
              medium: 8,
              large: 12,
            }}
          >
            <BodyCopy data-locator="pi-passwordtextinfo1" fontSize="fs14" fontFamily="secondary">
              {renderLabel(
                accountProfileLabels?.lbl_profile_password_info_line1,
                'lbl_profile_password_info_line1'
              )}
            </BodyCopy>
          </Col>
        </Row>
        <Row fullBleed>
          <Col
            colSize={{
              small: 6,
              medium: 8,
              large: 12,
            }}
          >
            <BodyCopy data-locator="pi-passwordtextinfo2" fontSize="fs14" fontFamily="secondary">
              {renderLabel(
                accountProfileLabels?.lbl_profile_password_info_line2,
                'lbl_profile_password_info_line2'
              )}
            </BodyCopy>
          </Col>
        </Row>
      </BodyCopy>
    </MyProfileTile>
  );
};

export default ChangePassword;
